module.exports = __webpack_public_path__ + "img/bg.6c32f59c.png";